module.exports = __webpack_public_path__ + "static/img/tabela.2861329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina/tabela.png
// module id = 7Ooy
// module chunks = 0